import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';

export const run =
  (config: ApiConfig) =>
  (data: Record<string, Record<string, any>>): Promise<Record<string, any>> =>
    fetchWrapper<Record<string, any>>(
      `${config.endpoint}combined`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
